import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {loginSchema} from '../../../components/utilities/models/gen-models';
import {useNavigate} from 'react-router-dom';
import axios from '../../../components/utilities/axios';
import {getDefaultRoute} from '../../../components/utilities/default-route';
import '../login/loginStyles.css'
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput, CImage,
  CInputGroup,
  CInputGroupText,
  CRow
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import {cilLockLocked, cilUser} from '@coreui/icons';
import cobwebimg from '../../../assets/images/secureme-logo2.png';

const SecureMeLogin = () => {
  const {register, handleSubmit,formState, formState: { errors }, reset} = useForm({
    resolver: yupResolver(loginSchema),
  });
  const { isSubmitting } = formState;
  const [loginError, setLoginError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [passwordShown, setPasswordShown] = useState(false);
  const [networkError, setNetworkError] = useState(null);
  // const [accessToken, setAccessToken] = useState('');
  const history = useNavigate();

  const handleLogin = async (details) => {
    await spinnerHandler();
    try {
      const {data} = await axios.post('/registrations/secureMeAccessApp', details);

      if (data.success) {
        await window.localStorage.setItem('y-z-main', 'true');
        await window.localStorage.setItem('y-z-access', data.token);
        // console.log('accessToken->>>>', login.data.token);
        // console.log('data login->>>>', data);
        localStorage.setItem('userId', data.userDetails.userId);
        localStorage.setItem('userData', JSON.stringify(data.userDetails));
        const defaultRoute = await getDefaultRoute(data.userDetails.roleId) || '/dashboard';
        history(
          defaultRoute,
          {state: {...data}}
        );
      } else {
        setLoginError(true);
        setErrorMessage(data.message);
      }
    } catch (e) {
      console.log(e)
      setNetworkError(e)
    }

  }

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  function spinnerHandler() {
    // return promise that resolves after 2 seconds
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  }
  return (
    <div className="bg-light min-h-100 d-flex flex-row align-items-center" style={{ position: 'relative', minHeight: '100vh' }}>
      <a href="/" className="btn btn-outline-secondary btn-sm" style={{ position: 'absolute', top: '20px', left: '20px', borderRadius: '8px', padding: '6px 16px', textDecoration: 'none' }}>
        &larr; Back to Home
      </a>
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup>
              <CCard className="p-5 border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                <CCardBody>
                  <CForm onSubmit={handleSubmit(handleLogin)}>
                    <div className="text-center mb-4">
                      <h2 className="fw-bold" style={{fontSize: '32px'}}><span>Secure</span> <span style={{color: '#33C3E9'}}>-ME</span></h2>
                      <p className="text-medium-emphasis">Sign In to your account</p>
                    </div>
                    <CInputGroup className="mb-3">
                      <CInputGroupText style={{ borderRadius: '12px 0 0 12px' }}>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput type="email" name="emailAddress" placeholder="email address" autoComplete="username" style={{ borderRadius: '0 12px 12px 0', height: '48px' }} {...register("emailAddress")}/>
                    </CInputGroup>
                    <div className="text-danger small mt-2">{errors.emailAddress?.message}</div>
                    <CInputGroup className="mb-4">
                      <CInputGroupText style={{ borderRadius: '12px 0 0 12px' }}>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type={passwordShown ? "text" : "password"}
                        placeholder="Password"
                        autoComplete="current-password"
                        style={{ borderRadius: '0 12px 12px 0', height: '48px' }}
                        {...register("password")}
                      />
                      <span className="input-group-text px-3 bg-transparent" id="visibilitySpan" onClick={togglePassword} style={{ cursor: 'pointer', borderRadius: '0 12px 12px 0' }}>
                        <i className={passwordShown ?"bi bi-eye-slash":"bi bi-eye"} />
                      </span>
                    </CInputGroup>
                    <span className="text-danger small mt-2">{errors.password?.message}</span>
                    {loginError && <div className="text-danger small text-center mb-3">{errorMessage}</div>}
                    {networkError ? <p className="text-danger small">An error occurred: {networkError.message}</p> : null}
                    <button style={{backgroundColor: '#33C3E9', color: 'white', borderRadius: '12px', padding: '12px 32px', width: '100%', border: 'none', fontSize: '16px', fontWeight: 600}} className="btn btn-lg" type="submit">
                      <div className="d-flex justify-content-center align-items-center">
                        {isSubmitting ? 'Processing...' : 'Sign in'}
                        {isSubmitting && <span className="spinner-grow spinner-grow-sm ms-2" />}
                      </div>
                    </button>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard className="text-white py-5 cobwebImage border-0" style={{ width: '35%', background: 'linear-gradient(135deg, #33C3E9 0%, #1a8bb5 100%)', borderRadius: '0 20px 20px 0' }}>
                <CCardBody className="text-center d-flex align-items-center justify-content-center">
                  <div>
                    <CImage src={cobwebimg} alt="cobweb image" style={{ maxWidth: '220px' }}/>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
};

export default SecureMeLogin;
